// extracted by mini-css-extract-plugin
module.exports = {"button":"_1b6e0b3","icon":"_c338aed"};